import { z } from "zod";

export const cloneAgreementSchema = z.object({
  name: z.string().trim().min(1),
  slugEntries: z
    .array(
      z.object({
        old_slug: z.string().trim().min(1),
        new_slug: z.string().trim().min(1),
      })
    )
    .min(1),
});

export type CloneAgreementFormValues = z.infer<typeof cloneAgreementSchema>;
